import { graphql } from '@api/gql';

export const STATUS_FIELD_FRAGMENT = graphql(/* GraphQL */ `
  fragment statusFields on Status {
    status
    message
  }
`);

export const OWNERS_FIELD_FRAGMENT = graphql(/* GraphQL */ `
  fragment ownersFields on ResourceOwner {
    attributeValue {
      id
      name
      type
      typDisplayName
    }
    integration {
      ...integrationFields
    }
  }
`);

export const TAGS_FIELD_FRAGMENT = graphql(/* GraphQL */ `
  fragment tagsFields on Tag {
    key
    value
  }
`);

export const PATH_FIELD_FRAGMENT = graphql(/* GraphQL */ `
  fragment pathFields on ResourcePath {
    key
    keyDisplayName
    value
  }
`);

export const DETAILED_RESOURCE_NODE_FIELDS_FRAGMENT = graphql(/* GraphQL */ `
  fragment detailedResourceNodeFields on Resource {
    id
    name
    path {
      ...pathFields
    }
    tags {
      ...tagsFields
    }
    owners {
      ...ownersFields
    }
    status {
      ...statusFields
    }
    type {
      ...resourceTypeFields
    }
    integration {
      ...integrationFields
    }
    riskLevel {
      ...riskLevelFields
    }
  }
`);

export const RESOURCE_NODE_FIELDS_FRAGMENT = graphql(/* GraphQL */ `
  fragment resourceNodeFields on Resource {
    id
    name
    status {
      ...statusFields
    }
    type {
      ...resourceTypeFields
    }
    integration {
      ...integrationFields
    }
    riskLevel {
      ...riskLevelFields
    }
  }
`);

export const PERMISSION_NODE_FIELDS_FRAGMENT = graphql(/* GraphQL */ `
  fragment permissionNodeFields on Permission {
    id
    name
    riskLevel {
      ...riskLevelFields
    }
  }
`);

export const PERMISSIONS_RISK_LEVEL_SUMMARY_FIELDS_FRAGMENT = graphql(/* GraphQL */ `
  fragment permissionsRiskLevelSummaryFields on RiskLevelSummary {
    highLevelCount
    mediumLevelCount
    lowLevelCount
  }
`);

export const inventoryResourcesQueryDocument = graphql(/* GraphQL */ `
  query InventoryResources($filter: InventoryFilterInput, $pagination: PaginationInput) {
    inventoryResources(filter: $filter, pagination: $pagination) {
      hasMore
      edges {
        cursor
        node {
          resource {
            ...resourceNodeFields
          }
          permissionsRiskLevelSummary {
            ...permissionsRiskLevelSummaryFields
          }
          entitlementsCount
          permissionsCount
        }
      }
    }
  }
`);

export const inventoryResourceQueryDocument = graphql(/* GraphQL */ `
  query InventoryResourceDetails($filter: InventoryFilterInput, $pagination: PaginationInput) {
    inventoryResources(filter: $filter, pagination: $pagination) {
      edges {
        node {
          resource {
            ...detailedResourceNodeFields
          }
          permissionsRiskLevelSummary {
            ...permissionsRiskLevelSummaryFields
          }
          entitlementsCount
          permissionsCount
        }
      }
    }
  }
`);

export const inventoryPermissionsQueryDocument = graphql(/* GraphQL */ `
  query InventoryPermissions($filter: InventoryFilterInput, $pagination: PaginationInput) {
    inventoryPermissions(filter: $filter, pagination: $pagination) {
      hasMore
      edges {
        node {
          ...permissionNodeFields
        }
        cursor
      }
    }
  }
`);
